import { render, staticRenderFns } from "./EditBotClientBtn.vue?vue&type=template&id=2aebce6e&"
import script from "./EditBotClientBtn.vue?vue&type=script&lang=js&"
export * from "./EditBotClientBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports